import { c as _c } from "react/compiler-runtime";
import { CONTACT_ASSISTANT_API } from 'modules/contacts/api/contact-api';
import { ContactFilterConditionInterface } from 'modules/contacts/types/contact-filter-interface';
import { ContactApiInterface } from 'modules/contacts/types/contact-interface';
import { useCallback } from 'react';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
interface UseContactsInterface extends SwrPaginationInterface {
  conditions: ContactFilterConditionInterface[];
}
export function useAssistantContacts(t0) {
  const $ = _c(18);
  const {
    limit,
    pagination,
    conditions
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== conditions) {
    t2 = conditions.map(_temp).join("");
    $[1] = conditions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const filterApi = t2;
  let t3;
  if ($[3] !== filterApi || $[4] !== limit || $[5] !== pagination || $[6] !== user) {
    t3 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${CONTACT_ASSISTANT_API}/contacts/list?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${CONTACT_ASSISTANT_API}/contacts/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[3] = filterApi;
    $[4] = limit;
    $[5] = pagination;
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: contacts,
    abort: abortList
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[8] !== filterApi || $[9] !== user) {
    t4 = () => {
      if (user) {
        return `${CONTACT_ASSISTANT_API}/contacts/count?pagination[limit]${filterApi}`;
      }
      return null;
    };
    $[8] = filterApi;
    $[9] = user;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: counter,
    abort: abortCounter
  } = useControlledSwr(t4, baseFetcher);
  let t5;
  if ($[11] !== abortCounter || $[12] !== abortList) {
    t5 = () => {
      abortList();
      abortCounter();
    };
    $[11] = abortCounter;
    $[12] = abortList;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const abortContacts = t5;
  let t6;
  if ($[14] !== abortContacts || $[15] !== contacts || $[16] !== counter) {
    t6 = {
      contacts,
      counter,
      abortContacts
    };
    $[14] = abortContacts;
    $[15] = contacts;
    $[16] = counter;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(el, idx) {
  return Object.keys(el).map(e => `&filter[conditions][${idx}][${e}]=${encodeURIComponent(el[e as keyof ContactFilterConditionInterface] as string)}`).join("");
}